<template>
  <div class="list-flashes">
    <!-- Filtro -->
    <b-row>
      <b-col md="2">
        <b-form-group>
          <label class="ml-2">{{$t('SEND_NEWS.Status')}}</label>
          <v-select
            v-model="eventStatus"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            class="form-control-sm event-status-field"
            :options="eventStatusData"
          >
            <!-- :placeholder="$t('SEND_NEWS.Status')" -->
            <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group>
          <label class="ml-2">Conteúdo</label>
          <v-select
            v-model="contentData"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            class="form-control-sm event-status-field"
            :options="contentList"
          >
            <!-- :placeholder="$t('SEND_NEWS.Status')" -->
            <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <label style="margin-left: 2px">{{$t('SEND_NEWS.Period')}}</label>
            <!-- :placeholder="$t('SEND_NEWS.Period')" -->
          <flat-pickr
            v-model="form.dtInterval"
            class="form-control-sm form-date"
            :config="{
              enableTime: false,
              dateFormat: 'Y-m-d',
              altInput: true,
              altFormat: 'd/m/Y',
              allowInput: true,
              mode: 'range',
            }"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <label style="margin-left: 2px">{{$t('SEND_NEWS.Title')}}</label>
          <b-form-input v-model="form.title" />
        </b-form-group>
      </b-col>

      <b-col md="2" class="pt-2">
        <!-- <b-button
          class="mr-1"
          variant="primary"
          size="sm"
          @click="loadData"
        >
          Filtrar
        </b-button> -->

        <b-button
          variant="flat-primary"
          class="btn-icon rounded-circle"
          size="sm"
          @click="loadData(false)"
        >
          <feather-icon icon="SearchIcon" />
        </b-button>
        <b-button
          variant="flat-danger"
          class="btn-icon rounded-circle"
          size="sm"
          @click="clearFilter"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </b-col>
    </b-row>

    <!-- List -->
    <b-row class="row-list">
      <div class="list-flashes-content">
        <b-list-group>
          <b-list-group-item>
            <div class="flex" style="align-items: center;">
              <div class="date" style="padding-right: 5px;min-width: 140px;">Data da publicação</div>
              <div style="min-width: 70%;max-width: 70%;padding: 0px 10px;">Manchete</div>
              <div>Conteúdo</div>
            </div>
          </b-list-group-item>
        </b-list-group>
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="scroll-area-list-flashes"
          :suppressScrollX="true"
        >
          <b-list-group v-if="data.length > 0">
            <b-list-group-item
              button
              v-for="(item, index) in data"
              :key="index"
              @click="onSelectItem(item)"
              :class="{'data-selected': checkSelectedData(item)}"
            >
              <div class="flex" style="align-items: center;">
                <div class="date" style="padding-right: 5px;min-width: 140px;">{{
                  formatDate(item.dt_create, {
                    dateStyle: "short",
                    timeStyle: "medium",
                  })
                }}</div>
                <div style="min-width: 70%;max-width: 70%;padding: 0px 10px;">{{ item.content.title.data }}</div>
                <div>{{item.newsContent.map(item => item.namePtBr).join(',')}}</div>
              </div>
            </b-list-group-item>
          </b-list-group>
          <div class="no-results" v-if="data.length == 0">
            <span class="not-found">
              <b-alert
                v-height-fade.appear
                variant="danger"
                :show="data.length == 0"
                class="mb-0"
              >
                <div class="alert-body">
                  <feather-icon icon="InfoIcon" class="mr-50" />
                  {{$t('MANAGE_NEWS.NotFound')}}
                </div>
              </b-alert>
            </span>
          </div>
        </vue-perfect-scrollbar>

        <b-pagination
          v-model="currentPage"
          pills
          :total-rows="totalRows"
          size="sm"
          align="right"
          @change="handleChangePage"
        />
      </div>
      <!-- <div class="form-label-group">
        <b-form-group>
          <b-form-checkbox-group v-model="piscaSelected" stacked>
            <vue-perfect-scrollbar
              class="list-content-scroll"
              :suppressScrollX="true"
            >
              <b-form-checkbox
                v-for="(item, index) in piscaData"
                :key="index"
                name="piscaD"
                :value="item"
                class="d-flex item-sidebar custom-control-warning"
                @change="onSelectItemPisca"
              >
                {{ item.dt_create }} - {{ item.value }}
              </b-form-checkbox>
            </vue-perfect-scrollbar>
          </b-form-checkbox-group>
        </b-form-group>
      </div> -->
    </b-row>

    <!-- Lista pisca -->
    <!-- <div class="form-label-group">
      <b-form-group>
        <b-form-checkbox-group v-model="piscaSelected" stacked>
          <vue-perfect-scrollbar
            class="list-content-scroll"
            :suppressScrollX="true"
          >
            <b-form-checkbox
              v-for="(item, index) in piscaData"
              :key="index"
              name="piscaD"
              :value="item"
              class="d-flex item-sidebar custom-control-warning"
              @change="onSelectItemPisca"
            >
              {{ item.dt_create }} - {{ item.value }}
            </b-form-checkbox>
          </vue-perfect-scrollbar>
        </b-form-checkbox-group>
      </b-form-group>
    </div> -->
  </div>
</template>

<script>
import { formatDate } from "@core/utils/filter";
import { ref } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import {
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BListGroup,
  BListGroupItem,
  BPagination,
  BFormInput,
  BAlert
} from "bootstrap-vue";
import newsService from "@/providers/newsService";
import AppConstants from "@/appConstants";
import { heightFade } from "@core/directives/animations";
import dropdownService from '@/providers/dropdownService';

export default {
  directives: {
    "height-fade": heightFade,
  },
  props: {
    relatedNews: {
      type: Boolean,
      default: () => false
    },
    isDisclosure: {
      type: Boolean,
      default: () => false
    },
    disclosureType: {
      type: Number,
      default: () => 0
    },
    selectedData: {
      default: () => null
    },
    origins: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    checkSelectedData(data) {
      if (!this.selectedData) return false;
      return this.selectedData._id === data._id;
    },
    // onSelectItemPisca(item) {
    //   if (item.length === 1) {
    //     this.form.title = item[0].value;
    //   } else {
    //     this.form.title = "";
    //   }
    // },
    onSelectItem(item) {
      if (this.relatedNews) {
        const selectedItem = { id: this.currentRelatedNewsId, news: item };
        this.$emit("select", selectedItem);
      } else {
        this.$emit("select", item);
      }
    },
  },
  watch: {
    eventStatus() {
      this.loadData(false);
    },
    contentData() {
      this.loadData(false);
    }
  },
  setup(props) {
    const currentNewsInvite = ref(1);
    const currentRelatedNewsId = ref(1);
    const perfectScrollbarSettings = ref({
      maxScrollbarLength: 60,
      wheelSpeed: 0.3,
      swipeEasing: true,
    });
    const form = ref({
      dtInterval: null,
      title: "",
    });

    const eventStatusData = ref([
      { id: AppConstants.EVENT_STATUS.PUBLISHED, name: 'Publicado' },
      { id: AppConstants.EVENT_STATUS.SAVED, name: 'Armazenado' },
    ]);
    const contentList = ref([]);
    // const eventStatusData = ref([
    //   { id: AppConstants.EVENT_STATUS.PUBLISHED, name: this.$t('MAIN_MENU.Status_Published') },
    //   { id: AppConstants.EVENT_STATUS.SAVED, name: this.$t('MAIN_MENU.Status_Stored') },
    // ]);
    const eventStatus = ref({});
    const contentData = ref({});
    const data = ref([]);
    const currentPage = ref(1);
    const totalRows = ref(0);
    const limit = ref(AppConstants.PAGINATOR_DEFAULT_LIMIT);

    eventStatus.value = eventStatusData.value[0];

    const clearFilter = () => {
      form.value.dtInterval = null;
      form.value.title = '';
      loadData();
    };

    const refreshList = () => {
      currentPage.value = 1;
      eventStatus.value = eventStatusData.value[0];
      loadData();
    };

    const searchParams = () => {
      const params = new URLSearchParams();
      params.append("page", currentPage.value);
      params.append("limit", limit.value);
      params.append("flashes", true);
      params.append("important", true);

      if (eventStatus.value) {
        params.append("event_status", eventStatus.value.id);
      }
      if (contentData.value && contentData.value.id) {
        params.append("content", contentData.value.id);
      }

      if (form.value.dtInterval) {
        params.append("dt_range", form.value.dtInterval);
      }
      if (form.value.title) {
          params.append("title", form.value.title);
      }
      if (props.relatedNews || props.isDisclosure) {
        params.delete('flashes');
        params.delete('important');
        params.delete('event_status');
        params.append("event_status", AppConstants.EVENT_STATUS.PUBLISHED);
        if (props.isDisclosure) {
          params.append("disclosureType", props.disclosureType);
        }
        if (props.relatedNews) {
          params.append("listFlashesRelatedNews", true);
        }
      }
      if (props.origins) {
        params.append("origins", props.origins.map(item => item.id).join(','));
      }
      return params;
    };

    const loadContentData = () => {
      const params = new URLSearchParams();
      if (props.origins) {
        params.append("origins", props.origins.map(item => item.id).join(','));
      }
      dropdownService.getContent(params).then((resp) => {
        contentList.value = resp;
      });
    };

    const loadData = (isPaginate = false) => {
      if (!isPaginate) {
        currentPage.value = 1;
        data.value = [];
      }
      newsService.manageNews(searchParams()).then((resp) => {
        totalRows.value = resp.totalRows;
        if (isPaginate) {
          data.value = data.value.concat(resp.data);
        } else {
          data.value = resp.data;
        }
      });
    };

    const handleChangePage = (page) => {
      currentPage.value = page;
      loadData(true);
    };

    loadContentData();
    loadData();

    return {
      // variables
      form,
      data,
      totalRows,
      currentPage,
      formatDate,
      eventStatus,
      eventStatusData,
      perfectScrollbarSettings,
      contentData,
      contentList,

      // functions
      clearFilter,
      handleChangePage,
      loadData,
      refreshList,
      currentRelatedNewsId,
      currentNewsInvite
    };
  },
  components: {
    BAlert,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BListGroup,
    BListGroupItem,
    BPagination,
    BFormInput,
    flatPickr,
    vSelect,
    VuePerfectScrollbar,
  },
};
</script>

<style>
</style>